<h2 mat-dialog-title style="font-weight:bold;">Select Export Format</h2>
<mat-dialog-content>
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Export Format</mat-label>
    <mat-select [(value)]="selectedFormat">
      <mat-option value="csv">CSV</mat-option>
      <mat-option value="xlsx">Excel</mat-option>
      <mat-option value="pdf">PDF</mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="custom-button-cancel" (click)="onCancel()">Cancel</button>
  <button mat-button class="custom-button" (click)="onExport()">Export</button>
</mat-dialog-actions>
